import { useEffect, useState } from "react";
import Spinner from "../component/Spinner";
import axiosInstance from "../networking/axiosconfig";
import Navbar from "./Navbar";
import { Settings, Edit } from "lucide-react";
import ChatbotPopup from "../component/chatbotPopup";

const GeneralSettingList = () => {
  const [settingList, setSettingList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [showChatbotPopup, setShowChatbotPopup] = useState(false);

  const genralSettingUrl = "/api/setting/";

  /* ================= FETCH SETTING LIST ================= */
  const fetchSettingList = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(genralSettingUrl);
      if (res.data && Array.isArray(res.data.data)) {
        setSettingList(res.data.data);
      } else {
        console.error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOAD ON PAGE ================= */
  useEffect(() => {
    fetchSettingList();
  }, []);

  /* ================= EDIT ================= */
  const handleEditClick = (id) => {
    setSelectedId(id);
    setShowChatbotPopup(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />

      {/* Popup */}
      {showChatbotPopup && (
        <ChatbotPopup
          selectedId={selectedId}
          onClose={() => {
            setShowChatbotPopup(false);
            fetchSettingList(); // ✅ refresh after update
          }}
        />
      )}

      <div className="max-w-7xl mx-auto p-6">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 p-3 rounded-lg">
              <Settings size={32} />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">
                General Setting List
              </h1>
              <p className="text-xs md:text-sm ml-1">
                Welcome to the General Setting List.
              </p>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="w-full">
          <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden mt-6">
            <thead className="bg-gradient-to-r from-blue-600 to-indigo-800 text-white">
              <tr>
                <th className="py-3 px-4 text-left text-sm font-semibold text-white">S.No.</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-white">Title</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-white">Key</th>
                <th className="py-3 px-4 text-left text-sm font-semibold text-white">Value</th>
                <th className="py-3 px-4 text-center text-sm font-semibold text-white">
                  Action
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center py-12">
                    <Spinner size={30} color="#3498db" loading />
                  </td>
                </tr>
              ) : settingList.length > 0 ? (
                settingList.map((item, index) => (
                  <tr
                    key={item.setting_id_PK}
                    className="hover:bg-gray-50"
                  >
                    <td className="px-4 py-4 text-sm">{index + 1}</td>
                    <td className="px-4 py-4 text-sm">{item.title}</td>
                    <td className="px-4 py-4 text-sm">{item.key}</td>
                    <td className="px-4 py-4 text-sm truncate max-w-xs">
                      {item.value}
                    </td>
                    <td className="px-4 py-4 text-center">
                      <button
                        onClick={() => handleEditClick(item.setting_id_PK)}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 transition text-xs font-semibold border border-purple-200"
                      >
                        <Edit size={12} />
                        Edit ChatBot
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-6 text-gray-500">
                    No settings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingList;
